export default __webpack_public_path__ + "static/media/backgroundImage.cbd3431e.svg";